/*
    Copyright 2022-2026, Techwise Integrated Security, LLC
*/

import React from "react";
import { Box, Divider, Link, Typography } from "@mui/material";

import DataObjectIcon from "@mui/icons-material/DataObject";
import GitHubIcon from "@mui/icons-material/GitHub";
import ContentCard from "../../components/general/ContentCard";
import StyledBreadcrumbs from "../../components/general/StyledBreadcrumbs";
import Grid from "@mui/material/Grid";
import { useWindowDimensions } from "../../utils/Hooks";

const About = () => {
    const { width } = useWindowDimensions();

    let numCols: number = 12;

    if (width >= 1500) {
        numCols = 4;
    }

    return (
        <Box>
            <StyledBreadcrumbs
                paths={[
                    { text: "Techwise Portal", route: "/" },
                    { text: "About", route: "/about" },
                ]}
            />

            <Divider sx={{ mb: 3 }} />

            <Typography fontWeight="bold" sx={{ mb: 2 }}>
                Copyright Info
            </Typography>

            <Typography>
                The Techwise Integrated Security Portal is owned and operated by Techwise Integrated Security, LLC.
            </Typography>
            <Typography marginBottom={4}>
                Copyright &copy; 2022-2026 Techwise Integrated Security, LLC. All rights reserved.
            </Typography>

            <Typography variant="h6">System Administrators</Typography>

            <Typography marginBottom={3}>
                <Link href="mailto:christina@techwiseis.com">Christina Drewry</Link>,&nbsp;
                <Link href="mailto:karisa@techwiseis.com">Karisa Stanley</Link>.
            </Typography>

            <Typography variant="h6">Developers</Typography>
            <Typography>
                <Link href="mailto:mathew.bartgis@gmail.com">
                    <b>Mathew Bartgis</b>
                </Link>
                &nbsp;-&nbsp;Chief Architect, Lead Developer
            </Typography>
            <Typography>
                <b>David Miller</b> - Senior QA Engineer
            </Typography>
            <Typography>
                <b>Connor Williams</b> - Senior Frontend Developer
            </Typography>
            <Typography>
                <b>Steven "Troy" Pruitt</b> - Junior Frontend Developer
            </Typography>
            <Typography>
                <b>Logan Croley</b> - Junior Frontend Developer
            </Typography>

            <Box marginBottom={5} />

            <code>Latest Update: February 8, 2026 | Portal Version: 2.3.5</code>

            <Divider sx={{ mb: 3, mt: 3 }} />

            <Typography fontWeight="bold" sx={{ mb: 2 }}>
                Documentation & Repositories
            </Typography>

            <Grid container xs={12}>
                <Grid xs={numCols} sx={{ p: 1 }}>
                    <ContentCard
                        title="API Documentation (Swagger)"
                        icon={<DataObjectIcon />}
                        description="The Techwise IS Portal backend documentation rendered using Swagger."
                        url={`${process.env.REACT_APP_API_ENDPOINT}/docs/swagger`}
                        targetBlank={true}
                    />
                </Grid>
                <Grid xs={numCols} sx={{ p: 1 }}>
                    <ContentCard
                        title="API Documentation (ReDoc)"
                        icon={<DataObjectIcon />}
                        description="The Techwise IS Portal backend documentation rendered using ReDoc."
                        url={`${process.env.REACT_APP_API_ENDPOINT}/docs/redoc`}
                        targetBlank={true}
                    />
                </Grid>
                <Grid xs={numCols} sx={{ p: 1 }}>
                    <ContentCard
                        title="Code Repositories"
                        icon={<GitHubIcon />}
                        description="The Techwise portal frontend and backend code can be found in respective private repositories located on Gitlab."
                        url="https://gitlab.com/techwise-is"
                        targetBlank={true}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default About;
